<div class="flex flex-col gap-5 p-6">
  <shared-modal-header>
    <ng-container title>
      @if (coverage(); as coverage) {
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
          <div class="flex items-center gap-1">
            <span class="text-xl font-bold">{{ coverage.packageCore.name }}</span>
            @if (coverage.packageCore.internalName) {
              <mat-icon
                class="text-neutral-400"
                [matTooltip]="coverage.packageCore.internalName"
                >info_outline</mat-icon
              >
            }
          </div>
          <span class="text-sm text-neutral-400">{{ ("packageConfigurator.label.activeFrom" | translate) + " " + formatDate(coverage.activeFrom) }}</span>
        </div>
      }
    </ng-container>
  </shared-modal-header>

  <members-package-coverage [userId]="data.userId"></members-package-coverage>
</div>
